/*
 * @Author: DESKTOP-FKE5GMS\17601 1760178806@qq.com
 * @Date: 2023-11-16 11:01:16
 * @LastEditors: DESKTOP-FKE5GMS\17601 1760178806@qq.com
 * @LastEditTime: 2023-11-16 16:37:54
 * @FilePath: \合联\oms\src\api\analysis\b2borderStatistics.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import axios, { buildApi } from '@/libs/api.request';
let name = '/report/dbl/'

export const apis = buildApi({
  get: [name + 'order', name + 'service/:type&service', name + 'customer/:type&customer',name + 'transport/:type&transport',],
})